import { createFileRoute } from "@tanstack/react-router";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuditableUrls } from "@/hooks/use-auditable-urls";
import { PageScanner } from "@/components/scanner/page-scanner";
import { ScannerEmptyState } from "@/components/scanner/scanner-empty-state";

export const Route = createFileRoute("/")({
  component: AccessibilityChecker,
});

function AccessibilityChecker() {
  const { data, isLoading, error } = useAuditableUrls();

  if (isLoading) {
    return (
      <div className="cy:bg-white cy:border cy:border-[#cacee4] cy:rounded-[12px] cy:px-8 cy:py-6">
        <div className="cy:flex cy:flex-col cy:gap-8">
          <div className="cy:flex cy:flex-col cy:gap-2">
            <Skeleton className="cy:h-6 cy:w-[240px]" />
            <Skeleton className="cy:h-4 cy:w-[420px]" />
          </div>
          <div className="cy:flex cy:gap-3 cy:items-center">
            <Skeleton className="cy:h-[44px] cy:w-[428px] cy:rounded-[4px]" />
            <Skeleton className="cy:h-[40px] cy:w-[120px] cy:rounded-[3px]" />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cy:bg-white cy:border cy:border-red-200 cy:rounded-[12px] cy:px-8 cy:py-6">
        <h2 className="cy:font-bold cy:text-[20px] cy:text-[#21242d]">
          Couldn't load URLs
        </h2>
        <p className="cy:mt-2 cy:text-[14px] cy:text-[#4e4b66]">
          {error.message ||
            "Something went wrong loading the page list. Refresh and try again."}
        </p>
      </div>
    );
  }

  const groups = data ?? {};
  const totalCount = Object.values(groups).reduce(
    (sum, items) => sum + items.length,
    0,
  );

  if (totalCount === 0) {
    return <ScannerEmptyState />;
  }

  return <PageScanner groups={groups} />;
}
